const MODULE_NAME = "MANAGE_LICENSES_PROVIDERS_";
const FETCH_PROVIDERS_STARTED = MODULE_NAME + 'FETCH_STARTED';
const FETCH_PROVIDERS_COMPLETED = MODULE_NAME + 'FETCH_COMPLETED';

export {
  FETCH_PROVIDERS_STARTED,
  FETCH_PROVIDERS_COMPLETED
};
